export default __webpack_public_path__ + "static/media/logo.037b2884.jpg";